import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import generatePicker from './generatePicker';
import './style';

const DatePicker = generatePicker(momentGenerateConfig);

export default DatePicker;
